import React, { useState, useEffect } from 'react'
import axios from 'axios'
import {
  TextField
} from '@material-ui/core'
import Autocomplete from '@material-ui/lab/Autocomplete'
import { useDispatch } from 'react-redux'
import { checkErrorStatus, setSnackbar } from 'utils/common/actions'
import { getIdArray, getUniqueArrayById } from 'helpers/dataHelpers'
import useStyles from './styles'
import Config from 'config'


const DomainsInput = (props) => {
  const localClasses = useStyles()
  const {
    error,
    helperText,
    setValue,
    defaultValue,
    single,
    variant,
    notRequired,
    additionalClasses,
    setRoomsOptions,
    setClientsValue,
    placeholder,
    InputLabelProps
  } = props
  const { apiUrl } = Config.network
  const dispatch = useDispatch()
  const [domains, setDomains] = useState([])
  const [value, setLocalValue] = useState(defaultValue || !single ? [] : null)

  const getDomains = () => {
    const url = `${apiUrl}domains/get_simple_list/`
    axios.get(url).then((body) => {
      const { data } = body
      setDomains(data)
    }).catch(error => {
      if (error.response) {
        dispatch(checkErrorStatus(error.response.status))
      } else {
        dispatch(setSnackbar('Connection error', 'error'))
      }
    })
  }

  useEffect(() => {
    getDomains()
    if (defaultValue) {
      if (!single) {
        setValue(getIdArray(defaultValue))
        setLocalValue(defaultValue)
        if (setRoomsOptions) {
          let rooms = []
          for (let i = 0, length = defaultValue.length; i < length; i += 1) {
            rooms = [...defaultValue[i].rooms, ...rooms]
          }
          const uniqueRooms = getUniqueArrayById(rooms)
          setRoomsOptions(uniqueRooms)
        }
      } else {
        setValue(defaultValue)
        setLocalValue(defaultValue)
        if (setRoomsOptions) {
          setRoomsOptions(defaultValue.rooms)
        }
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const handleChange = (event, newValue) => {
    setLocalValue(newValue)
    if (!single) {
      setValue(getIdArray(newValue))
      if (setRoomsOptions) {
        let rooms = []
        for (let i = 0, length = newValue.length; i < length; i += 1) {
          rooms = [...newValue[i].rooms, ...rooms]
        }
        const uniqueRooms = getUniqueArrayById(rooms)
        setRoomsOptions(uniqueRooms)
      }
      if (setClientsValue) {
        let clients = []
        for (let i = 0, length = newValue.length; i < length; i += 1) {
          clients = [...newValue[i].clients, ...clients]
        }
        const uniqueClients = getUniqueArrayById(clients)
        setClientsValue(uniqueClients)
      }
    } else {
      setValue(newValue)
      if (setRoomsOptions && newValue) {
        setRoomsOptions(newValue.rooms)
      } else if (setRoomsOptions) {
        setRoomsOptions([])
      }
      if (setClientsValue && newValue) {
        setClientsValue(newValue.clients)
      } else if (setClientsValue) {
        setClientsValue([])
      }
    }
  }

  const setDefaultValue = () => {
    if (defaultValue) {
      return defaultValue
    }
    if (single) {
      return null
    }
    return []
  }

  return (
    <Autocomplete
      value={value}
      onChange={handleChange}
      getOptionSelected={(option, value) => option.id === value.id}
      multiple={!single}
      filterSelectedOptions
      options={domains}
      className={`${localClasses.domainsAutocomlete} ${additionalClasses || ''}`}
      autoHighlight
      fullWidth
      defaultValue={setDefaultValue()}
      getOptionLabel={(domain) => domain.name}
      renderOption={(domain) => (
        <React.Fragment>
          {domain.name}
        </React.Fragment>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label='Domains'
          variant={variant || 'outlined'}
          fullWidth
          required={!notRequired}
          error={error}
          helperText={helperText}
          name='domains'
          InputLabelProps={InputLabelProps}
          color='secondary'
          placeholder={placeholder || 'Select domains...'}
        />
      )}
    />
  )
}

export default DomainsInput
